import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "verification" }
const _hoisted_2 = { class: "max-mobile-width" }
const _hoisted_3 = { class: "verification-form" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = { class: "alert alert-danger" }
const _hoisted_6 = { class: "mt-4 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.verification && _ctx.verification(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-center mb-4 mt-4" }, [
          _createElementVNode("img", { src: 'img/logo.png' })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-center mb-4 mt-4" }, [
            _createElementVNode("h1", { class: "text-decoration-underline mb-3 mt-5" }, "Ověřte přihlášení SMS kódem"),
            _createElementVNode("p", null, "Z bezpečnostních důvodů si potřebujeme ověřit, Že jste to skutečně vy. Proto jsme na vaše zařízení odeslali SMS zprávu s potvrzovacím kódem, který opiště do políčka níže. ")
          ], -1)),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"display":"inline-block","width":"150px"},
              autocomplete: "one-time-code",
              placeholder: "Kód",
              id: "kod",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.kod) = $event))
            }, null, 512), [
              [_vModelText, _ctx.kod]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary ms-2",
              style: {"margin-top":"-3px"}
            }, "Přihlásit", -1))
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-4 text-center" }, null, -1))
        ])
      ])
    ], 32)
  ]))
}